// libs
import React, { memo } from 'react';

// styles
import {
  Container,
  Images,
  Thumbnails,
  Thumbs,
  MainImage,
  Details,
  Title,
  SubTitle,
  Price,
  ShimmerLine,
  ColorSection,
  ColorTitle,
  ColorValue,
  ColorOptions,
  ColorOption,
  SizeSection,
  SizeTitle,
  SizeOptions,
  SizeOption,
  Actions,
  WishlistButton,
  AddToBagButton,
} from './styles';

// constants
import { BUTTON_TEXT, THUMBNAIL_COUNT, WISHLIST_BUTTON_TEXT } from './constants';

function Placeholder() {
  return (
    <Container>
      <Images>
        <Thumbnails aria-hidden="true">
          {Array.from({ length: THUMBNAIL_COUNT }, (_, index) => (
            <Thumbs key={`placeholder-thumbnail-${index}`} />
          ))}
        </Thumbnails>
        <MainImage />
      </Images>
      <Details>
        <Title />
        <SubTitle />
        <Price />


        <ShimmerLine />
        <ShimmerLine />
        <SubTitle />
        <ColorSection>
          <ColorTitle />
          <ColorValue />
          <ColorOptions>
            <ColorOption />
            <ColorOption />
          </ColorOptions>
        </ColorSection>

        <SizeSection>
          <SizeTitle />
          <SizeOptions>
            {Array.from({ length: 5 }, (_, index) => (
              <SizeOption key={`placeholder-size-option-${index}`} />
            ))}
          </SizeOptions>
        </SizeSection>

        <Actions aria-hidden="true">
          <WishlistButton>{WISHLIST_BUTTON_TEXT}</WishlistButton>
          <AddToBagButton>{BUTTON_TEXT}</AddToBagButton>
        </Actions>
      </Details>
    </Container>
  );
}

export default memo(Placeholder);
